import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faShieldCheck,
  faTruck,
  faBox,
  faClock,
  faArrowRight,
  faArrowLeft,
  faStar,
  faPlus,
  faMinus,
} from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStarRegular, faInfoCircle, faQuestionCircle, faClose } from '@fortawesome/pro-regular-svg-icons';

library.add(
  faShieldCheck,
  faTruck,
  faBox,
  faClock,
  faArrowRight,
  faArrowLeft,
  faStar,
  faStarRegular,
  faPlus,
  faMinus,
  faInfoCircle,
  faQuestionCircle,
  faClose,
);

dom.watch();
